import "./Aircrafts.scss";
import React, {
  useState,
  useEffect,
  ChangeEvent,
  useRef,
  MouseEvent,
} from "react";

import { GrView } from "react-icons/gr";
import Select from "react-select";
// import { MultiValue, ActionMeta } from "react-select";
import Modal from "@mui/material/Modal";
import { TbEdit } from "react-icons/tb";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaEllipsisH } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import { RiArrowDropUpLine } from "react-icons/ri";
import { BsPlusLg } from "react-icons/bs";
import aircraft_image from "../../../assets/images/aircraft_img.svg";
import { FaPlane } from "react-icons/fa";
import {
  deleteaircraft,
  getAircraft,
} from "../../../components/Axios/Axios";
import AddAircraftModal from "../../../components/Modal/AddAircraftModal";
import LayoutProvider from "../../../providers/LayoutProvider";
import ViewAircraftModal from "./viewAircraftModal";
import EditAircraftModal from "./editAircraftModal";
import ReactPaginate from "react-paginate";
import { Dropdown } from "react-bootstrap";
const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};
// Define the options for the Autolog Frequency dropdown
const autologOptions = ["Every Flight", "Every other Flight", "Always"];

function Aircrafts() {

  const [aircraftData, setAircraftData] = useState<any>([]);
  const [addAircraft, setAddAircraft] = React.useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const itemsPerPage = 10;
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [selectedAircraft, setSelectedAircraft] = useState<any>([]);
  const [selectedAircraftData, setSelectedAircraftData] = useState<any>([]);
  const [numEntries, setNumEntries] = useState(0);

  const menuRef = useRef<HTMLDivElement | null>(null); // Specify the type for menuRef
  const handleOpenModal = () => {
    setIsViewModalOpen(true);
  };

  const handleClickOutside = (event: MouseEvent) => {
    // Specify the event type
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      // Click occurred outside the menu, so close it
      setSelectedRow(null);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent<Element, MouseEvent>) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setSelectedRow(null);
      }
    };

    const addClickEvent = () => {
      document.addEventListener(
        "click",
        handleClickOutside as unknown as EventListener
      );
    };

    const removeClickEvent = () => {
      document.removeEventListener(
        "click",
        handleClickOutside as unknown as EventListener
      );
    };

    // Add event listener to the document when the menu is open
    if (selectedRow !== null) {
      addClickEvent();
    } else {
      removeClickEvent();
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      removeClickEvent();
    };
  }, [selectedRow]);


  const handleContextMenuClick = (
    event: React.MouseEvent<HTMLDivElement>,
    data: any
  ) => {
    event.preventDefault();
    setSelectedAircraftData(data);
    console.log("Seleceteddddd Aircraftt:", data);
    setIsContextMenuOpen(!isContextMenuOpen);
  };

  const handleViewClick = (flight: any) => {
    setSelectedAircraft(flight);
    setIsViewModalOpen(true);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };


  const handleEditClick = (flight: any) => {
    setSelectedAircraft(flight);
    setEditModalOpen(true);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
    setSelectedAircraft(null);
    setEditModalOpen(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleDelete = async (flightId: string) => {
    try {
      // Make an API request to delete the flight using deleteFlight function
      await deleteaircraft(flightId);
      // If deletion is successful, call triggerRefresh to refresh the Flights component
      setRefresh(refresh + 1);
    } catch (error) {
      console.error("Error deleting flight:", error);
    }
  };


  const handleAddAircraft = () => {
    setAddAircraft(true);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
    setNumEntries((prevNumEntries) => prevNumEntries + 1);
  };


  React.useEffect(() => {
    async function fetchData() {
      try {
        const data = await getAircraft();
        const data3 = data;
        setAircraftData(data3);
        setNumEntries(data3.length);
        console.log("ada", data)
      } catch (error) {
        console.error("Error fetching aircraft data:", error);
      }
    }
    fetchData();
  }, [refresh, numEntries]);

  const totalPages = Math.ceil(aircraftData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = aircraftData.slice(startIndex, endIndex);

  const handlePageChange = ({ selected }: { selected: number }) => {
    setCurrentPage(selected + 1); // Adjust currentPage value to start from 1
  };

  return (
    <LayoutProvider>
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="dashboard_heading">My Aircrafts</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Aircrafts</h6>
      </section>
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {/* <div style={{ display: "flex", gap: "15px" }}>
          <button className="filter_btn">
            Filter <RiArrowDropUpLine />
          </button>
          <button className="filter_btn">
            Filter <RiArrowDropUpLine />
          </button>
        </div> */}
        <button
          className="button heading4"
          onClick={handleAddAircraft}
        >
          <BsPlusLg /> Add Aircraft
        </button>
        <AddAircraftModal open={addAircraft} onClose={handleCloseAircraft} />
      </section>
      <div className="image-card-container">
        {itemsToDisplay.map((data: any, index: any) => (
          <div className="image-card-container" key={data.id}>
            <div className="image-card">
              <img src={aircraft_image} alt="Card" className="card-image" />
              <div className="card-content">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h2
                    className="heading3"
                    style={{
                      position: "relative",
                      fontWeight: "600",
                      paddingLeft: "5%",
                    }}
                  >
                    {data.model}
                  </h2>
                  <div style={{ position: "absolute", right: 0 }}>
                    <div
                      className="edit_menu"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleContextMenuClick(event, data);
                        setSelectedRow(selectedRow === index ? null : index);
                      }}
                      ref={menuRef}
                    >
                      <FaEllipsisH className="edit_dots" />
                    </div>
                    {selectedRow === index && (
                      <ul
                        style={{ position: "relative", zIndex: "5" }}
                        className="edit_menu_ul"
                      >
                        <li>
                          <button
                            style={{
                              textDecoration: "none",
                              background: "transparent",
                              border: "none",
                              outline: "none",
                            }}
                            className="heading4"
                            onClick={() => {
                              handleViewClick(data);
                            }}
                          >
                            View
                          </button>
                        </li>
                        <li>
                          <button
                            
                            style={{
                              textDecoration: "none",
                              background: "transparent",
                              border: "none",
                              outline: "none",
                            }}
                            className="heading4"
                            onClick={() => {
                              handleEditClick(data);
                            }}
                          >
                            Edit
                          </button>
                        </li>
                        <li>
                          <button
                            className="delete_btn heading4"
                            onClick={() => handleDelete(data._id)}
                          >
                            Delete
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                  {/* <Dropdown >
                    <Dropdown.Toggle id="dropdown-basic" style={{ background: "none", color: "#5b5b5b", border: "none" }}>
                      <FaEllipsisH />
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{inset: "-15px auto auto 0px !important"}}>
                      <Dropdown.Item onClick={() => {handleViewClick(data);}} >View</Dropdown.Item>
                      <Dropdown.Item type='button' onClick={() => handleDelete(data._id)}>Delete</Dropdown.Item>
                      <Dropdown.Item  onClick={() => handleEditClick(data)}>Edit</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
                <p
                  className="heading5 text_color2"
                  style={{ paddingLeft: "5%" }}
                >
                  Body Type - {data.bodyType}
                </p>
                <p
                  className="heading5 text_color2"
                  style={{ paddingLeft: "5%" }}
                >
                  Engine Type - {data.engineType}
                </p>
                <div style={{ display: "flex" }}>
                  <p
                    className="heading5 text_color2"
                    style={{ paddingLeft: "5%" }}
                  >
                    <FaPlane className="secondary" /> {data.landing} Flights
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}

        <ViewAircraftModal
          isViewModalOpen={isViewModalOpen}
          handleCloseModal={handleCloseModal}
          selectedAircraftData={selectedAircraftData}
        />


        {/* View Modalllll End */}

        {/* Edit Modalllll */}
        <EditAircraftModal
          isEditModalOpen={isEditModalOpen}
          handleCloseModal={handleCloseModal}
          selectedAircraftData={selectedAircraftData}
          // setSelectedAircraftData={setSelectedAircraftData}
          setEditModalOpen={setEditModalOpen}
        />
        {/* Edit Modalllll end*/}
      </div>
      <div className="pagination-container-one">
        <ReactPaginate
          previousLabel="Prev"
          nextLabel="Next"
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
    </LayoutProvider>
  );
}


export default Aircrafts;


